<template>
  <v-chip v-if="side" :size="size" :color="side.color" variant="flat">{{ side.label }}</v-chip>
  <span v-else class="text-medium-emphasis">{{ fallback }}</span>
</template>

<script setup>
import { computed } from 'vue';
import helper from '@/helpers/helper';

const props = defineProps({
  direction: { type: String, default: null },
  size: { type: String, default: 'small' },
  fallback: { type: String, default: '—' },
});

const side = computed(() => helper.tradeSide(props.direction));
</script>
